import { isEncryptionEnabled } from '~libs/encryptionSettings';

import { SearchProps } from '~components/form-fields/search';

import { MANDATE_STATUS_OPTIONS } from '~direct-debits/models';

export const searchFields: SearchProps = {
  client_name: {
    defaultShow: true,
    type: 'text-like',
    field: ['first_name', 'surname', 'full_name'],
    placeholder: 'Client Name',
    caption: 'Client Name',
    hidden: isEncryptionEnabled,
  },
  status: {
    defaultShow: true,
    type: 'multi-lookup',
    field: 'status',
    placeholder: 'All',
    caption: 'Mandate Status',
    options: MANDATE_STATUS_OPTIONS,
  },
};
